export function blogFilters() {
	const filterForm = document.getElementById('filter-form');
	if (!filterForm) return;

	let page = 1;

	function toggleMobileCategoriesHandler() {
		const toggler = document.querySelector('[data-mobile-categories-toggler]');
		if (!toggler) return;

		const categoriesContainer = toggler
			.closest('.categories-block__body')
			.querySelector('.categories-outer');
		if (!categoriesContainer) return;

		toggler.addEventListener('click', () => {
			categoriesContainer.classList.toggle('expanded');
			toggler.classList.toggle('active');
		});
	}

	function categoryCheckboxesHandler() {
		const categoryList = document.querySelector('.categories-block__list');
		const checkboxes = document.querySelectorAll('.category-checkbox');
		const clearBtn = document.querySelector('[data-clear-action]');
		const applyBtn = document.querySelector('[data-apply-action]');
		const selectedCount = document.querySelector('[data-selected-categories-count]');

		if (checkboxes.length === 0 || !categoryList || !clearBtn || !applyBtn) return;

		categoryList.addEventListener('change', () => {
			let checkboxesUnchecked = true;
			let count = 0;
			checkboxes.forEach((checkbox) => {
				if (checkbox.checked) {
					checkboxesUnchecked = false;
					count++;
					applyBtn.dataset.selectedCheckboxesCount = count;
					if (count === 1) {
						applyBtn.dataset.selectedCategoryUrl = checkbox.dataset.url;
					} else {
						applyBtn.dataset.selectedCategoryUrl = '';
					}
				}
			});
			if (!checkboxesUnchecked) {
				clearBtn.disabled = false;
				applyBtn.disabled = false;
				if (selectedCount) selectedCount.innerText = `(${count})`;
			} else {
				clearBtn.disabled = true;
				applyBtn.disabled = true;
				if (selectedCount) selectedCount.innerText = '';
			}
		});

		categoryList.addEventListener('change', () => {
			const selectedCategories = Array.from(checkboxes)
				.filter((checkbox) => checkbox.checked)
				.map((checkbox) => checkbox.value);
			applyBtn.dataset.categories = JSON.stringify(selectedCategories);
		});
	}

	function resetForm(requestAfterReset = true) {
		const clearBtn = document.querySelector('[data-clear-action]');
		const applyBtn = document.querySelector('[data-apply-action]');
		const selectedCount = document.querySelector('[data-selected-categories-count]');

		filterForm.reset();
		if (clearBtn) clearBtn.disabled = true;
		if (applyBtn) {
			applyBtn.disabled = true;
			applyBtn.dataset.selectedCheckboxesCount = 0;
			applyBtn.dataset.selectedCategoryUrl = '';
		}
		if (selectedCount) selectedCount.innerText = '';

		if (requestAfterReset) {
			handleFilters();
		}
	}

	function filterCategoriesInputHandler() {
		const filterInput = document.getElementById('category-search');
		const categoryLabels = document.querySelectorAll('label.category-title');

		if (!filterInput || !categoryLabels.length) return;

		filterInput.addEventListener('input', (event) => {
			let filterValue = event.target.value;
			if (/^\d/.test(filterValue)) return;

			filterValue = filterValue.toLowerCase();
			categoryLabels.forEach((label) => {
				if (label.textContent.toLowerCase().includes(filterValue)) {
					label.closest('li').style.display = 'block';
				} else {
					label.closest('li').style.display = 'none';
				}
			});
		});
	}

	function applyFilters(currentPage, deleteExisting = true) {
		const loadMoreBtn = document.getElementById('load-more');
		const casesCategoryBtn = document.getElementById('cases-category-btn');

		let selectedCategories = [];
		document.querySelectorAll('input[name="category[]"]:checked').forEach((input) => {
			selectedCategories.push(input.value);
		});

		const sortChecked = document.querySelector('input[name="sort"]:checked') ||
			document.querySelector('input[name="sort-mobile"]:checked');
		const sortOption = sortChecked ? sortChecked.value : '';
		const searchInput = document.querySelector('input[name="search"]');
		const searchQuery = searchInput ? searchInput.value : '';

		const params = new URLSearchParams();
		params.set('action', 'filter_blog');
		if (selectedCategories.length) params.set('category', selectedCategories.join(','));
		if (sortOption) params.set('sort', sortOption);
		if (searchQuery) params.set('search', searchQuery);
		params.set('paged', currentPage);

		fetch(ajaxUrl + '?' + params.toString())
			.then((res) => res.json())
			.then((response) => {
				const container = document.getElementById('filtered-posts');
				if (!container) return;

				if (deleteExisting) container.innerHTML = '';
				container.insertAdjacentHTML('beforeend', response.posts);

				if (!response.has_more) {
					if (loadMoreBtn) loadMoreBtn.style.display = 'none';
				} else {
					if (loadMoreBtn) {
						loadMoreBtn.style.display = 'inline-block';
						loadMoreBtn.dataset.max = response.max_num_pages;
					}
				}
				page++;
				if (casesCategoryBtn) casesCategoryBtn.disabled = false;
			})
			.catch((error) => console.error('Filter error:', error))
			.finally(() => {
				if (loadMoreBtn) {
					loadMoreBtn.disabled = false;
					loadMoreBtn.classList.remove('is-loading');
				}
			});

		document.body.classList.remove('scroll-lock');
	}

	function handleFilters() {
		page = 1;
		const loadMoreBtn = document.getElementById('load-more');
		if (loadMoreBtn) {
			loadMoreBtn.dataset.page = 1;
			loadMoreBtn.style.display = 'inline-block';
		}
		applyFilters(page);
	}

	function sortHandler() {
		const sortInputs = document.querySelectorAll('input[name="sort"]');
		const sortMobileInputs = document.querySelectorAll('input[name="sort-mobile"]');

		sortInputs.forEach((input) => {
			input.addEventListener('change', () => {
				document.querySelectorAll('input[name="category[]"]').forEach((cb) => cb.checked = false);
				sortMobileInputs.forEach((mi) => mi.checked = false);
				handleFilters();
			});
		});

		sortMobileInputs.forEach((input) => {
			input.addEventListener('change', () => {
				document.querySelectorAll('input[name="category[]"]').forEach((cb) => cb.checked = false);
				sortInputs.forEach((si) => si.checked = false);
				handleFilters();

				if (window.innerWidth < 768) {
					setTimeout(() => {
						const wrapper = document.querySelector('.categories-block__wrapper');
						if (wrapper) wrapper.classList.remove('visible');
					}, 300);
				}
			});
		});
	}

	function searchHandler() {
		const searchInput = document.getElementById('search-input');
		const searchBtn = document.getElementById('search-btn');

		if (searchInput) {
			searchInput.addEventListener('keypress', (e) => {
				if (e.key === 'Enter') {
					e.preventDefault();
					handleFilters();
				}
			});
		}

		if (searchBtn) {
			searchBtn.addEventListener('click', () => {
				if (searchInput && searchInput.value.trim() === '') {
					searchInput.focus();
				} else {
					handleFilters();
				}
			});
		}
	}

	function applyBtnClickHandler(event) {
		const categoryUrl = event.currentTarget.dataset.selectedCategoryUrl;
		const checkboxesCount = event.currentTarget.dataset.selectedCheckboxesCount;
		const isCategoryPage = event.currentTarget.dataset.isCategoryPage;
		const categories = JSON.parse(event.currentTarget.dataset.categories || '[]');

		if (categoryUrl && checkboxesCount && +checkboxesCount === 1) {
			window.location.href = categoryUrl;
		} else if (checkboxesCount && +checkboxesCount > 1 && isCategoryPage === 'true') {
			if (categories.length > 0) {
				const queryString = `categories=${encodeURIComponent(categories.join(','))}`;
				const newUrl = `${window.location.origin}/blog/?${queryString}`;
				window.location.href = newUrl;
			}
		} else {
			applyFilters(page);
			setTimeout(() => {
				const wrapper = document.querySelector('.categories-block__wrapper');
				if (wrapper) wrapper.classList.remove('visible');
			}, 500);
		}
	}



	function addEventListeners() {
		const clearBtn = document.querySelector('[data-clear-action]');
		const applyBtn = document.querySelector('[data-apply-action]');
		const loadMoreBtn = document.getElementById('load-more');
		const casesCategoryBtn = document.getElementById('cases-category-btn');

		if (clearBtn) {
			clearBtn.addEventListener('click', () => resetForm());
		}

		if (applyBtn) {
			applyBtn.addEventListener('click', applyBtnClickHandler);
		}

		if (loadMoreBtn) {
			loadMoreBtn.addEventListener('click', (event) => {
				const btn = event.currentTarget;
				if (btn.disabled) return;
				btn.disabled = true;
				btn.classList.add('is-loading');
				applyFilters(++btn.dataset.page, false);
			});
		}

		if (casesCategoryBtn) {
			casesCategoryBtn.addEventListener('click', () => {
				const casesCategoryId = +casesCategoryBtn.dataset.casesCategoryId;
				if (casesCategoryId === 0) return;

				resetForm(false);

				const casesCategoryCheckbox = document.getElementById(`catid_${casesCategoryId}`);
				if (casesCategoryCheckbox) {
					casesCategoryCheckbox.checked = !casesCategoryCheckbox.checked;
					casesCategoryCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
				}

				if (applyBtn) applyBtn.click();
				casesCategoryBtn.disabled = true;
			});
		}
	}

	// Init
	resetForm(false);
	addEventListeners();
	toggleMobileCategoriesHandler();
	categoryCheckboxesHandler();
	filterCategoriesInputHandler();
	sortHandler();
	searchHandler();
}
